import React, { useEffect, useRef } from 'react';
import proptypes from 'prop-types';

const { func, node } = proptypes;

export const ActionBarIntersectionObserver = ({ children, setIntersecting, }) => {
  const ref = useRef(null);
  const observer = useRef(null);

  const disconnect = () => {
    if (observer.current && observer.current.disconnect) {
      observer.current.disconnect();
    }
  };

  useEffect(() => {
    return () => { disconnect(); };
  }, []);

  useEffect(() => {
    if (!ref.current) return;

    observer.current = new IntersectionObserver(async ([entry]) => {
      if (!entry || entry?.intersectionRatio < 0) return;
      setIntersecting(entry.isIntersecting);
    });

    observer.current.observe(ref.current);

  }, [ref, setIntersecting]);

  return (
    <div data-testid="sticky-action-observer" style={{ width: '100%' }} ref={ref}>
      {children}
    </div>
  );
};

ActionBarIntersectionObserver.propTypes = {
  children: node.isRequired,
  setIntersecting: func.isRequired
};
